'use client';

import { c as _c } from "react/compiler-runtime";
import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';
import { create } from 'zustand';
import { DONATION_ROUTES, ENV, MODULE_ROUTES, ROUTES, SEARCH_PARAMS, STORAGE_KEY } from '@/constants';
import { useAuthStore } from '@/stores/AuthStore';
import { isCanonicalDetailRedirectSourcePathname } from '../_utils/isCanonicalDetailRedirectSourcePathname';
import { isCanonicalSlugRedirect } from '../_utils/isCanonicalSlugRedirect';
import { isKbHistoryExceptRoute } from '../_utils/kbHistoryExceptRoutes';
import { moveBackInfo } from '../_utils/moveBackInfo';
import { isKbWebview } from '../_utils/nativeCall';
import { setTopMenuV2 } from '../_utils/setTopMenuV2';
import { KB_DUMMY_PATHNAME, KB_DUMMY_PATHNAME_SPLIT_POINT } from './kbHistoryConstants';
export { KB_DUMMY_PATHNAME, KB_DUMMY_PATHNAME_SPLIT_POINT };
interface KbHistoryStore {
  historyList: string[];
  setHistoryList: (setter: (history: string[]) => string[]) => void;
}
const kbHistoryStore = create<KbHistoryStore>(set => ({
  historyList: [],
  setHistoryList: setter => set(state => ({
    historyList: setter(state.historyList)
  }))
}));
export const KbHistoryStack = () => {
  const $ = _c(13);
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const isLogin = useAuthStore(_temp);
  let t0;
  let t1;
  if ($[0] !== pathname) {
    t0 = () => {
      if (!pathname) {
        return;
      }
      if (!isKbWebview()) {
        const isAllowedPath = ["/login", "/join", "/terms", "/easy-certification", "/filter", "/donation"].some(path => pathname.startsWith(path));
        if (!isAllowedPath) {
          const originalWello = ENV.NEXT_PUBLIC_DOMAIN;
          location.href = location.href.replace(location.origin, originalWello);
        }
      }
    };
    t1 = [pathname];
    $[0] = pathname;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  useEffect(_temp2, t2);
  let t3;
  if ($[4] !== pathname) {
    t3 = isKbHistoryExceptRoute(pathname);
    $[4] = pathname;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const isExceptRoute = t3;
  let t4;
  let t5;
  if ($[6] !== isExceptRoute || $[7] !== isLogin || $[8] !== pathname || $[9] !== searchParams) {
    t4 = () => {
      if (!pathname || isExceptRoute || !isKbWebview() || !isLogin) {
        return;
      }
      if (isCanonicalDetailRedirectSourcePathname(pathname)) {
        return;
      }
      const shouldUseKbDummyPathname = pathname !== ROUTES.SEARCH.pathname;
      let kbDummyPathname = pathname;
      const params = {};
      const url = new URL(pathname, location.origin);
      searchParams?.forEach((value, key) => {
        if (key === SEARCH_PARAMS.POST_REDIRECT) {
          return;
        }
        if (shouldUseKbDummyPathname) {
          const lastChar = kbDummyPathname.slice(-1);
          kbDummyPathname = kbDummyPathname + `${lastChar === "/" ? "" : "/"}${KB_DUMMY_PATHNAME}${KB_DUMMY_PATHNAME_SPLIT_POINT}${key}${KB_DUMMY_PATHNAME_SPLIT_POINT}${value}`;
        } else {
          url.searchParams.set(key, value);
        }
        params[key] = value;
      });
      if (shouldUseKbDummyPathname) {
        url.pathname = kbDummyPathname;
      }
      const {
        historyList,
        setHistoryList
      } = kbHistoryStore.getState();
      const lastHistory = historyList[historyList.length - 1];
      const historyUrl = url.toString();
      const isNewHistory = lastHistory !== historyUrl;
      if (!isNewHistory) {
        return;
      }
      const hasReplaceMarkKb = sessionStorage.getItem(STORAGE_KEY.REPLACE_MARK_KB) === "true";
      if (hasReplaceMarkKb) {
        sessionStorage.removeItem(STORAGE_KEY.REPLACE_MARK_KB);
      }
      bb58: switch (pathname) {
        case ROUTES.GATEWAY.pathname:
          {
            if (historyList.length > 0) {
              return;
            }
            const homeUrl = new URL(MODULE_ROUTES.KB_HOME.pathname, location.origin).toString();
            const donationHomeUrl = new URL(DONATION_ROUTES.HOME.pathname, location.origin).toString();
            moveBackInfo(homeUrl, {}, "Y", "addHistoryStackThisDonationHome");
            setHistoryList(() => [homeUrl, donationHomeUrl]);
            break bb58;
          }
        default:
          {
            if (isCanonicalSlugRedirect(lastHistory, pathname)) {
              moveBackInfo(historyUrl, params, "Y", undefined, true);
              setHistoryList(history => history.length > 0 ? [...history.slice(0, -1), historyUrl] : [historyUrl]);
            } else {
              moveBackInfo(historyUrl, params);
              setHistoryList(history_0 => [...history_0, historyUrl]);
            }
          }
      }
    };
    t5 = [isExceptRoute, isLogin, pathname, searchParams];
    $[6] = isExceptRoute;
    $[7] = isLogin;
    $[8] = pathname;
    $[9] = searchParams;
    $[10] = t4;
    $[11] = t5;
  } else {
    t4 = $[10];
    t5 = $[11];
  }
  useEffect(t4, t5);
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <></>;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
function _temp(state) {
  return state.isLogin;
}
function _temp2() {
  setTopMenuV2("", "", {
    menuBt: "Y",
    preBt: "Y",
    close: "N",
    title: "\uB9DE\uCDA4\uD615 \uC815\uCC45\uC9C0\uC6D0\uAE08 \uC54C\uB9BC",
    preAction: "B",
    target: ""
  });
}